<template>
  <div data-testid="enrollment-ranking-editable">
    <v-btn
      @click.stop.prevent="$emit('move', -1)"
      :disabled="!(index > 0)"
      :loading="processing"
      :size="buttonSize"
      class="me-3"
      color="primary"
      icon="expand_less"
      variant="outlined"
    />

    <SelectionRanking
      :index="index"
      :ranking-suffix="rankSuffix"
    />

    <v-btn
      @click.stop.prevent="$emit('move', 1)"
      :disabled="!(length > index + 1)"
      :loading="processing"
      :size="buttonSize"
      class="ms-3"
      color="primary"
      icon="expand_more"
      variant="outlined"
    />
  </div>
</template>

<script setup>
import SelectionRanking from '@/shared/components/subsidy/SelectionRanking.vue';

defineEmits(['move']);
defineProps({
  buttonSize: {
    type: String,
    default: 'small',
  },
  index: {
    type: Number,
    default: null,
  },
  length: {
    type: Number,
    default: null,
  },
  processing: {
    type: Boolean,
    default: false,
  },
  rankSuffix: {
    type: String,
    default: 'choice',
  },
});
</script>
